import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'form[nttForm]',
  host: {
    '[attr.novalidate]': '""',
  },
})
export class NttForm {
  @HostListener('submit', ['$event'])
  submit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
